(function () {
/*
 * -----------------------------------------------------------------------------
 * @cam/input-number-rounding
 * -----------------------------------------------------------------------------
 * @version 0.0.1
 * @overview Rounds an inputs number value to specified decimals.
 * @copyright 2021 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
*/ if (customElements.get("input-number-rounding") === undefined) {
    class inputNumberRounding extends HTMLElement {
        constructor(){
            super();
            this.style.display = "contents";
            this.input = this.querySelector("input");
            if (!this.input) return;
            this.decimals = Number(!this.attributes["data-decimals"] ? 2 : this.attributes["data-decimals"].value);
            this.input.addEventListener("input", this.updateEvent.bind(this));
        }
        updateEvent(event) {
            const currentValue = Number(event.target.value);
            const newValue = Number(this.roundValue(currentValue, this.decimals));
            if (newValue === currentValue) return;
            this.input.value = newValue;
            this.input.dispatchEvent(new Event("input"));
        }
        roundValue(number, decimals) {
            const signum = number >= 0 ? 1 : -1;
            return (Math.round(number * Math.pow(10, decimals) + signum * 0.0001) / Math.pow(10, decimals)).toFixed(decimals);
        }
    }
    customElements.define("input-number-rounding", inputNumberRounding);
}



})();
